import { setContext } from 'apollo-link-context'
// apollo-boost installs this link; reuse it instead of adding another package.
// eslint-disable-next-line import/no-extraneous-dependencies
import { onError } from 'apollo-link-error'
import { ApolloClient, HttpLink, InMemoryCache } from 'apollo-boost'
import useJwt from '@/auth/jwt/useJwt'

const authLink = setContext(async (_, { headers }) => ({
  headers: {
    ...headers,
    Authorization: `Bearer ${localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)}`,
  },
}))

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_NOVITATUS_GRAPHQL,
})

const errorLink = onError(({ networkError, operation }) => {
  const current = useJwt.getToken()
  const headers = operation.getContext().headers || {}
  if (networkError && networkError.statusCode === 401 && current && headers.Authorization === `Bearer ${current}`) {
    useJwt.invalidateSession()
  }
})

// Apollo Graphql
export default new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: new InMemoryCache(),
})
